import { render, staticRenderFns } from "./TsDialog.vue?vue&type=template&id=af7dd656&scoped=true"
import script from "./TsDialog.vue?vue&type=script&lang=js"
export * from "./TsDialog.vue?vue&type=script&lang=js"
import style0 from "./TsDialog.vue?vue&type=style&index=0&id=af7dd656&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7dd656",
  null
  
)

export default component.exports